export default __webpack_public_path__ + "static/media/crop.9dbb66c2.svg";